import type { AxiosResponse } from 'axios';

/**
 * Unwrap a bare-axios response for the dispatch-board services.
 *
 * The app's GLOBAL axios response interceptor (src/helpers/api_helper.ts)
 * already returns `response.data` for every call. These dispatch services use
 * that same global axios instance, so `axios.get<T>(...)` resolves to the
 * BODY (`T`) at runtime — even though axios still types it as
 * `AxiosResponse<T>`. Doing `.then(r => r.data)` therefore double-unwraps to
 * `undefined` (the body has no `.data` property), which silently blanks the
 * UI on a 200.
 *
 * Use `.then(unwrap)` instead: it returns the already-unwrapped body, typed
 * correctly as `T`. (Cast is required because the static type still claims
 * `AxiosResponse<T>` even though the interceptor changed the runtime value.)
 */
export function unwrap<T>(r: AxiosResponse<T>): T {
  return r as unknown as T;
}
